import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4850af30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-header" }, "CHOOSE YOUR EXTRAS", -1))
const _hoisted_3 = { class: "extras-tab" }
const _hoisted_4 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Accordion, { activeIndex: 0 }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, { header: "FINISHES" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addons, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "extras-option",
                  key: item.id
                }, [
                  _createElementVNode("img", {
                    class: _normalizeClass(
                _ctx.selectedAddons.find((el) => el.id === item.id) ? 'active' : ''
              ),
                    src: require(`@/assets/img/${item.id}.png`),
                    alt: "",
                    onClick: ($event: any) => (_ctx.selectAddon(item))
                  }, null, 10, _hoisted_4),
                  _createElementVNode("div", null, _toDisplayString(item.name.toUpperCase()), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}